import { Link } from "react-router-dom";

export const HomePage = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Welcome to <span className="text-blue-200">AvtechAI</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-blue-100">
              Innovative AI Solutions & Cloud Consulting
            </p>
            <p className="text-lg mb-8 max-w-3xl mx-auto">
              Empowering businesses with cutting-edge technology solutions. From
              AI-powered applications to cloud architecture, we transform your
              vision into reality.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/products"
                className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
              >
                Explore Our Products
              </Link>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors"
              >
                Get In Touch
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What We Offer
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive technology solutions tailored to your business needs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* AI Solutions */}
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-blue-600 rounded-lg mb-6 flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                AI-Powered Applications
              </h3>
              <p className="text-gray-600">
                Intelligent solutions that leverage machine learning and AI to
                automate processes and provide insights.
              </p>
            </div>

            {/* Cloud Solutions */}
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-green-600 rounded-lg mb-6 flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Cloud Architecture
              </h3>
              <p className="text-gray-600">
                Scalable, secure, and cost-effective cloud solutions on AWS with
                serverless and microservices architecture.
              </p>
            </div>

            {/* Web Development */}
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-purple-600 rounded-lg mb-6 flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Modern Web Apps
              </h3>
              <p className="text-gray-600">
                Full-stack web applications built with modern frameworks like
                React, Node.js, and TypeScript.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Our Products
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Purpose-built tools for options traders and global professionals
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Spread Genius */}
            <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-2xl p-8 border border-blue-100 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  Live
                </span>
                <span className="bg-white border border-blue-200 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold">
                  Schwab API Powered
                </span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Spread Genius
              </h3>
              <p className="text-gray-600 mb-6 flex-1">
                Options trading analytics platform. Upload Schwab or Fidelity
                CSV exports to analyze your spread history — or connect your
                live Schwab account for real-time positions, the covered-call
                scanner, Risk Radar, and high-conviction signals.
              </p>
              <div className="grid grid-cols-2 gap-2 mb-6 text-sm">
                {[
                  "CSV strategy detection",
                  "Live Schwab positions",
                  "Covered call scanner",
                  "Risk Radar",
                  "CSP scoring",
                  "Monday signal scan",
                ].map((f) => (
                  <div
                    key={f}
                    className="flex items-center gap-1.5 text-gray-700"
                  >
                    <svg
                      className="w-3.5 h-3.5 text-green-500 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {f}
                  </div>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/products/spread-genius"
                  className="bg-blue-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-blue-700 transition-colors text-center text-sm"
                >
                  Learn More
                </Link>
                <a
                  href="https://sprdgen.avtechai.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-blue-600 text-blue-600 px-6 py-2.5 rounded-lg font-semibold hover:bg-blue-600 hover:text-white transition-colors text-center text-sm inline-flex items-center justify-center gap-1"
                >
                  Launch App
                  <svg
                    className="w-3.5 h-3.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>
              </div>
            </div>

            {/* Expat Horizon */}
            <div className="bg-gradient-to-br from-slate-700 to-indigo-900 rounded-2xl p-8 text-white flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  Now Live
                </span>
                <span className="bg-white/10 border border-white/20 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  Cross-Border Finance
                </span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                Expat Horizon
              </h3>
              <p className="text-blue-200 mb-6 flex-1">
                Lifetime financial planning for Indian professionals in the US
                and Canada. Monte Carlo retirement projections, cross-border
                withdrawal optimization, and FBAR/DTAA compliance awareness —
                all in one unified view.
              </p>
              <div className="grid grid-cols-2 gap-2 mb-6 text-sm">
                {[
                  "Monte Carlo projections",
                  "US · Canada · India",
                  "Withdrawal optimization",
                  "FBAR / FATCA awareness",
                  "DTAA tax modeling",
                  "Household planning",
                ].map((f) => (
                  <div
                    key={f}
                    className="flex items-center gap-1.5 text-blue-100"
                  >
                    <svg
                      className="w-3.5 h-3.5 text-orange-300 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {f}
                  </div>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/products/expat-horizon"
                  className="bg-orange-500 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-orange-400 transition-colors text-center text-sm"
                >
                  Learn More
                </Link>
                <a
                  href="https://expat-horizon.avtechai.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-white/40 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-white/10 transition-colors text-center text-sm"
                >
                  Launch App
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Transform Your Business?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Let's discuss how we can help you leverage AI and cloud technologies
            to achieve your goals.
          </p>
          <Link
            to="/contact"
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors inline-flex items-center"
          >
            Start Your Project
            <svg
              className="w-4 h-4 ml-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </Link>
        </div>
      </section>
    </div>
  );
};
